import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Provajder } from './provajder';

@Component({
  selector: 'app-provajder',
  templateUrl: './provajder.component.html'
})
export class ProvajderComponent extends BaseModalContainer<Provajder> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Provajder>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
